import '../styles/Loader.css'

// <!-- From Uiverse.io by adamgiebl --> 
export default function Loader() {
  return (
    <>
      <section className="dots-container">
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
      </section>
    </>
  )
}